import { switchAnatomy as b } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as d, defineStyle as l } from "@chakra-ui/styled-system";
import { cssVar as i, calc as h } from "@chakra-ui/theme-tools";
const { defineMultiStyleConfig: f, definePartsStyle: a } = d(b.keys), t = i("switch-track-width"), e = i("switch-track-height"), s = i("switch-track-diff"), m = h.subtract(t, e), c = i("switch-thumb-x"), r = i("switch-bg"), u = l((o) => {
  const { colorScheme: n } = o;
  return {
    borderRadius: "full",
    p: "0.5",
    width: [t.reference],
    height: [e.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    [r.variable]: "colors.onSurface.lowEmphasis",
    _dark: {
      [r.variable]: "colors.whiteAlpha.400"
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _readOnly: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      [r.variable]: "colors.".concat(n, ".500"),
      _dark: {
        [r.variable]: "colors.".concat(n, ".200")
      }
    },
    bg: r.reference
  };
}), w = l({
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [e.reference],
  height: [e.reference],
  _checked: {
    transform: "translateX(".concat(c.reference, ")")
  }
}), g = a((o) => ({
  container: {
    [s.variable]: m,
    [c.variable]: s.reference,
    _rtl: {
      [c.variable]: h(s).negate().toString()
    }
  },
  track: u(o),
  thumb: w
})), y = {
  sm: a({
    container: {
      [t.variable]: "1.375rem",
      [e.variable]: "sizes.3"
    }
  }),
  md: a({
    container: {
      [t.variable]: "1.875rem",
      [e.variable]: "sizes.4"
    }
  }),
  lg: a({
    container: {
      [t.variable]: "2.875rem",
      [e.variable]: "sizes.6"
    }
  })
}, k = f({
  baseStyle: g,
  sizes: y,
  defaultProps: {
    size: "md",
    colorScheme: "indigo"
  }
});
export {
  k as switchTheme
};
